<mat-label>
  {{ label }} {{ required ? '*' : ''}}
</mat-label>
<div class="selection-list-wrapper">
  @if (clinicId) {
    <div>
      <mat-selection-list class="!pt-0 !pb-0" color="primary" [disabled]="readOnly || selectionFormControl.disabled" (selectionChange)="onSelectAllChange($event)">
        <mat-list-option
          [value]="SELECT_ALL"
          [selected]="isSelectAllProvidersChecked"
          class="sticky-option"
          >
          Select All Providers
        </mat-list-option>
      </mat-selection-list>
      <mat-selection-list class="scrollable-selection-list" color="primary" [disabled]="readOnly || selectionFormControl.disabled" (selectionChange)="onProvidersSelectionChange($event)">
        <div class="m-2 grid grid-cols-1 gap-2">
          @for (option of listOptions; track option; let i = $index) {
            <mat-list-option
              [value]="option.id"
              [selected]="isProviderSelected(option.id)"
              [class.removal-requested]="isRemovalRequested(option.id)"
              [disabled]="readOnly || selectionFormControl.disabled || isRemovalRequested(option.id)"
              class="flex"
              >
              <div class="option-row">
                <div class="left">
                  <span class="option-label" [class.strike]="isRemovalRequested(option.id)">
                    {{ option.firstName }} {{ option.lastName }}@if (option.degree) {
                    , {{ option.degree }}
                  }
                </span>
                @if (isRemovalRequested(option.id)) {
                  <mat-icon color="warn" inline class="x-icon">close</mat-icon>
                  <span class="removal-text">Provider Removal Requested</span>
                }
              </div>
              @if (showRequestRemovalClinicOption && !readOnly) {
                <div class="right inline-block">
                  @if (!isRemovalRequested(option.id)) {
                    <button mat-button color="warn" class="link-btn warn" (click)="$event.stopPropagation(); requestClinicRemoval(option.id)">Remove Provider from Clinic</button>
                  }
                  @if (isRemovalRequested(option.id)) {
                    <button mat-button color="primary" class="link-btn" (click)="$event.stopPropagation(); undoClinicRemoval(option.id)">Undo Request</button>
                  }
                </div>
              }
            </div>
          </mat-list-option>
        }
      </div>
    </mat-selection-list>
    <mat-accordion [togglePosition]="'before'" #panel>
      @if (otherProviderNameFormControl && otherProviderNPIFormControl) {
        <mat-expansion-panel
          class="add-provider-panel !pt-0 !pb-0"
          color="primary"
          [disabled]="readOnly || selectionFormControl.disabled"
          [expanded]="isOtherProviderSelected"
          (expandedChange)="onOtherProviderExpandedChange($event)"
          hideToggle
          >
          <mat-expansion-panel-header>
            <mat-panel-title title="Add New Provider" class="add-provider-panel-title">
              <mat-icon inline>{{ isOtherProviderSelected ? 'remove' : 'add' }}</mat-icon>
              Add New Provider
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="flex flex-col flex-wrap gap-4 mt-2 p-4 justify-center">
            <mat-form-field class="w-full !mt-0" appearance="fill">
              <mat-label>Provider Name</mat-label>
              <input matInput [formControl]="otherProviderNameFormControl">
              @if (showError && otherProviderNameFormControl.hasError('required')) {
                <mat-error>
                  Provider Name is required.
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="w-full !mt-0" appearance="fill">
              <mat-label>Provider NPI</mat-label>
              <input matInput [formControl]="otherProviderNPIFormControl" maxlength="10" pattern="\d{10}" (keypress)="allowOnlyDigits($event)">
              @if (showError && otherProviderNPIFormControl.hasError('required')) {
                <mat-error>
                  Provider NPI is required.
                </mat-error>
              }
              @if (showError && otherProviderNPIFormControl.hasError('pattern')) {
                <mat-error>
                  Provider NPI should be 10 digits.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
}
@if (!clinicId) {
  <div class="p-8 text-center text-gray-500">
    <p>Please select a clinic to view available providers.</p>
  </div>
}
</div>
@if (showError && selectionFormControl.hasError('required')) {
  <mat-error>
    Please select at least one provider.
  </mat-error>
}
